var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBreadcrumbs)?_c('b-breadcrumb',{staticClass:"m-0"},[(_vm.items[0].path !== _vm.PATH_ROOT)?_c('BreadcrumbItem',{attrs:{"label":_vm.rootLabel,"last":false,"index":0,"path":"root"}}):_vm._e(),_vm._l((_vm.items),function(ref,index){
var label = ref.label;
var path = ref.path;
return _c('BreadcrumbItem',{key:'breadcrumb' + path,attrs:{"label":label,"last":_vm.items.length-1 === index,"path":path}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }